import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Days of the week contacts should move to next action", -1)
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-800 font-medium" }, "Time of day", -1)

import { watch } from "vue"
import GgmsMultiSelect from "@/components/GgmsMultiSelect.vue"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { CalendarNodeType } from "@/shared/models/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'WeekDaysComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const daysOptions = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

const radioButtonsOptions = [
    { displayName: "Delay until the same time of day that the contact entered the delay", value: "now" },
    { displayName: "Specific time", value: "time" },
]

watch(
    () => workflowStore.modelValue.event,
    () => {
        if (workflowStore.modelValue.event !== "time") {
            workflowStore.modelValue.time = ""
        }
    }
)

watch(
    () => [workflowStore.modelValue.days, workflowStore.modelValue.event, workflowStore.modelValue.time],
    () => {
        workflowStore.areButtonDisabled =
            workflowStore.modelValue.days &&
            workflowStore.modelValue.event &&
            workflowStore.modelValue.event === "time" &&
            workflowStore.modelValue.time
                ? false
                : !(
                      workflowStore.modelValue.days &&
                      workflowStore.modelValue.event &&
                      workflowStore.modelValue.event !== "time"
                  )
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsMultiSelect, {
      modelValue: _unref(workflowStore).modelValue.days,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.days) = $event)),
      options: daysOptions,
      placeholder: "Choose day or days",
      classes: "w-full"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(GgmsRadioSelect, {
        modelValue: _unref(workflowStore).modelValue.event,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
        options: radioButtonsOptions
      }, null, 8, ["modelValue"]),
      (_unref(workflowStore).modelValue.event === _unref(CalendarNodeType).time)
        ? (_openBlock(), _createBlock(GgmsInput, {
            key: 0,
            modelValue: _unref(workflowStore).modelValue.time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
            class: "pt-4",
            label: "Select time",
            type: "time",
            iconStart: _unref(ClockIcon)
          }, null, 8, ["modelValue", "iconStart"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})